import Table from 'components/Table'
import Select from 'components/Form/Select'
import { IResponse } from 'interfaces'
import useFetch from 'hooks/useFetch'
import { useEffect, useRef, useState, useContext } from 'react'
import { UserContext } from 'context'
import { IMAGES } from 'configs/configs.js'
import { Form } from '@unform/web'
import { Icon } from 'assets/index'
import DefaultButton from 'components/Buttons/DefaultButton'
import { Text, Status, SmallRow, Wrapper, Cell, Trash } from './style'

const mock = [
  {
    name: 'Fernando Oliveira Souza Andrade',
    amount: 'R$ 2.000,00',
    participation: 20,
    specialist: {
      name: 'Jonas',
      profilePic: 'teste.png',
    },
    status: 'Realizado',
  },
  {
    name: 'Ricardo Schun',
    amount: 'R$ 2.000,00',
    participation: 0,
    specialist: {
      name: 'Maria Elisa da Silva',
      profilePic: 'teste.png',
    },
    status: 'Pendente',
  },
  {
    name: 'Carlos Alberto',
    amount: 'R$ 2.000,00',
    participation: 20,
    specialist: {
      name: 'Warren Buffet',
      profilePic: 'teste.png',
    },
    status: 'Realizado',
  },
  {
    name: 'Sílvio Santos',
    amount: 'R$ 2.000,00',
    participation: 20,
    specialist: {
      name: 'Warren Buffet',
      profilePic: 'teste.png',
    },
    status: 'Realizado',
  },
  {
    name: 'Camila Andrade',
    amount: 'R$ 2.000,00',
    participation: 20,
    specialist: {
      name: 'Fernando Lemos',
      profilePic: 'teste.png',
    },
    status: 'Realizado',
  },
]

interface IProps {
  cotasAmount?: number
  disableDelete?: boolean
}

const UsersTable = (props: any) => {
  const { cotasAmount, disableDelete, data = [] } = props
  const [clients, setClients] = useState<any>([])
  const { selectedId } = useContext(UserContext)
  const [group, setGroup] = useState<any>(data)
  const [newClient, setNewClient] = useState<any>()
  // const [arr, setArr] = useState(data)
  const formRef = useRef<HTMLFormElement | any>(null)
  const api = useFetch()

  useEffect(() => {
    const promises = [
      // api.fetch('get'),
      api.fetch('get', null, `/gestor/account`),
    ]
    Promise.all(promises)
      .then((res) => {
        // const [caption, users] = res
        const [users] = res
        // if (caption.fail) throw new Error(caption.errors.message)
        if (users.fail) throw new Error(users.errors.message)
        setClients(
          users.data.data.map((item: any) => {
            return {
              value: item.document,
              label: item.name,
              id: item.id,
            }
          })
        )
        //     setGroup(caption.data.data.group)
      })
      .catch((e: any) => console.log(e))
  }, [])

  const handleDelete = async (id: string) => {
    try {
      const response: IResponse = await api.fetch(
        'delete',
        null,
        `/gestor/contract/client/${selectedId.current}?accountId=${id}`
      )
      if (response.fail) throw new Error(response.errors.message)
      const newArr = group.filter((item: any) => item.id !== id)
      setGroup(newArr)
    } catch (err: any) {
      console.log('err', err)
    }
  }

  const handleAdd = async () => {
    console.log(newClient)
    if (cotasAmount === group.length) return
    if (!newClient) return
    const hasClient = group.find((client: any) => client.id === newClient?.id)
    if (hasClient) return
    try {
      const response: IResponse = await api.fetch(
        'post',
        null,
        `/gestor/contract/client/${selectedId.current}?accountId=${newClient.id}`
      )
      if (response.fail) throw new Error(response.errors.message)
      console.log(response.data.data)
      // const newArr = group.push(response.data.data)
      setGroup(response.data.data)
    } catch (err: any) {
      console.log('err', err)
    }
  }

  function tableRows(arr: any) {
    if (!arr) return []
    return arr.map((item: any, i: number) => {
      return [
        <Cell>
          <Text medium>{i + 1}</Text>
        </Cell>, // Indice
        <Cell>
          <Text>{item.name}</Text>
        </Cell>, // nome
        <Cell>
          <Text error={item.status === 'Pendente'}>{item.amount}</Text>
        </Cell>, // valor investido
        <Cell>
          <Text>{item.rate}%</Text>
        </Cell>, // participacao
        <Cell>
          <SmallRow>
            <div className="pic-wrapper">
              <img
                className="specialist-pic"
                src={`${IMAGES.URL}/images/${item.specialist.profilePic}`}
                alt="profile"
              />
            </div>
            <Text>{item.specialist.name}</Text>
          </SmallRow>
        </Cell>, // especialista
        <Cell>
          <Status error={item.status === 'Pendente'}>{item.status}</Status>
        </Cell>, // Status
        <Cell>
          <Trash
            disableDelete={disableDelete}
            src={Icon('trash.svg')}
            alt="column sorting"
            onClick={() => !disableDelete && handleDelete(item.id)}
            style={{ marginLeft: '20%' }}
          />
        </Cell>, // Ações
      ]
    })
  }

  return (
    <Wrapper>
      <DefaultButton
        tertiary
        small
        icon={Icon('chevron_up.svg')}
        onClick={() => console.log('la')}
      >
        Participantes
      </DefaultButton>
      <div style={{ height: 32 }} />
      <Table
        data={tableRows(group)}
        header={[
          '#',
          'NOME DOS INVESTIDORES',
          'VALOR INVESTIDO',
          'PARTICIPAÇÃO',
          'ESPECIALISTA',
          'STATUS',
          'AÇÃO',
        ]}
      />
      {!disableDelete && (
        <Form ref={formRef} onSubmit={() => console.log('submit')}>
          <SmallRow style={{ marginTop: 32, alignItems: 'flex-start' }}>
            <Select
              placeholder="CPF / CNPJ do cliente"
              name="clients"
              options={clients}
              searchbar
              onChange={(e: any) => {
                // const repeated = selectedClients.find((item: any) => item.id === e.id)
                // if (repeated) return
                setNewClient(e)
              }}
              value={newClient}
            />
            <div style={{ marginLeft: 24 }}>
              <DefaultButton
                small
                icon={Icon('plus.svg')}
                onClick={() => handleAdd()}
              >
                Incluir Investidor
              </DefaultButton>
            </div>
          </SmallRow>
        </Form>
      )}
    </Wrapper>
  )
}

export default UsersTable
